import { Trash2 } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "./ui/sheet";
import { TrashList } from "./TrashList";
import { tr } from "../lib/i18n";

// "Recently deleted" side panel on /vault (owner + partner).
export const TrashSheet = ({ open, onClose, onChanged }) => (
  <Sheet open={open} onOpenChange={(v) => !v && onClose()}>
    <SheetContent data-testid="trash-sheet" className="w-full sm:max-w-md overflow-y-auto p-0">
      <div className="h-1.5 w-full bg-primary" />
      <div className="p-6">
        <SheetHeader className="text-left">
          <SheetTitle className="font-serif text-2xl flex items-center gap-2"><Trash2 className="h-5 w-5 text-primary" /> {tr("Recently deleted")}</SheetTitle>
          <SheetDescription>{tr("Deleted documents wait here for 30 days. Restore one with a tap, or delete it forever to shred the file now.")}</SheetDescription>
        </SheetHeader>
        <div className="mt-5"><TrashList onChanged={onChanged} /></div>
      </div>
    </SheetContent>
  </Sheet>
);
